// extracted by mini-css-extract-plugin
export default {"thumbnailWrapper":"SingleMediaPreview_thumbnailWrapper__p3pwI","thumbnail":"SingleMediaPreview_thumbnail__47eIE","productNameRow":"SingleMediaPreview_productNameRow__5U4K0"};